<template>
    <div class="content-type-34">
        <div v-if="loading" class="loading-spinner-type-1 primary"></div>
        <div
            class="title"
            v-else-if="hasMediumScreen && pagination && Math.ceil(total / pagination.limit) > 1 && total > 1"
            v-html="$t(`${i18nString}.results_count.p`, { found: formatNumber(total) }) + ' <span>-</span> ' + $t(`${i18nString}.results_count.page`, { page: formatNumber(pagination.page), total: formatNumber(Math.ceil(total / pagination.limit)) })"
        />
        <div
            class="title"
            v-else
            v-html="$t( (total === 0 || total > 1) ? `${i18nString}.results_count.p` : `${i18nString}.results_count.s`, { found: formatNumber(total) })"
        />
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useScreenWidthStore } from '@/stores/utils/screenWidth';
    import { formatNumber } from '@/utils/formatting';
    export default {
        name: 'CompaniesHeader',
        props: {
            total: {
                type: Number,
                default: 0
            },
            pagination: {
                type: Object,
                required: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            i18nString: {
                type: String,
                default: 'views.companies'
            }
        },
        computed: {
            ...mapState(useScreenWidthStore, ['hasMediumScreen']),
        },
        methods: {
            formatNumber
        }
    }
</script>